var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarUnavailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 47,
    viewBox: "0 0 48 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.2 3.9998H38.4V0.799805H35.2V3.9998H12.8V0.799805H9.6V3.9998H4.8C2.08 3.9998 0 6.0798 0 8.7998V41.5998C0 44.3198 2.08 46.3998 4.8 46.3998H43.2C45.92 46.3998 48 44.3198 48 41.5998V8.7998C48 6.0798 45.92 3.9998 43.2 3.9998ZM4.8 7.1998H9.6V10.3998H12.8V7.1998H35.2V10.3998H38.4V7.1998H43.2C44.16 7.1998 44.8 7.8398 44.8 8.7998V14.3998H3.2V8.7998C3.2 7.8398 3.84 7.1998 4.8 7.1998ZM43.2 43.1998H4.8C3.84 43.1998 3.2 42.3998 3.2 41.5998V17.5998H44.8V41.5998C44.8 42.5598 44.16 43.1998 43.2 43.1998ZM26.24 30.3998L31.84 35.9998L29.6 38.2398L24 32.6398L18.4 38.2398L16.16 35.9998L21.76 30.3998L16.16 24.7998L18.4 22.5598L24 28.1598L27.36 24.7998L29.6 27.0398L26.24 30.3998ZM31.04 21.1198L33.28 23.3598L31.04 25.5998L28.8 23.3598L31.04 21.1198Z",
    fill: "#3E7D34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarUnavailable);
export default __webpack_public_path__ + "static/media/calendar-unavailable.7b564fc76bb959b6ba415f3b757c524b.svg";
export { ForwardRef as ReactComponent };